import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';

import App from './App';

import billingPortalReducers from 'dataflow/billingPortal/reducers';
import distributorPortalrootReducers from 'dataflow/distributorPortal/reducers';

import { unregister } from './registerServiceWorker';


import 'bootstrap/dist/css/bootstrap.min.css';

const logger = store => next => action => {
    // console.group(action.type)
    // console.info('dispatching', action)
    let result = next(action)
    // console.log('next state', store.getState());
    // console.groupEnd();
    return result
}
const middlewareEnhancer = applyMiddleware(logger, thunkMiddleware);

const composedEnhancers = compose(
    middlewareEnhancer,
);

const rootReducer = combineReducers({ ...billingPortalReducers, ...distributorPortalrootReducers });
const store = createStore(rootReducer, undefined, composedEnhancers);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();

